const menus = [
  {
    id: 'orderManager',
    icon: 'fa fa-pagelines',
    label: '我的工单',
    submenu: [
      {id: 'ordertpl', path: '/ordertpl/list', label: '新建工单'},
      {id: 'suborder', path: '/submitted/order', label: '工单状态'},
    ]
},
  {
    id: 'monitorManager',
    icon: 'fa fa-cogs',
    label: '监控管理',
    submenu: [
      {id: 'monitor-setting', path: '/monitor/setting/', label: '监控配置'},
      {id: 'monitor-list', path: '/monitor/list/', label: '监控展示'},
      {id: 'monitor-mantian',path: '/monitor/maintian',label:'屏蔽展示'},
      {id: 'monitor-fastalarm',path: '/monitor/fastalarm',label:'快速报警配置'},
      {id: 'monitor-report',path: '/monitor/report',label:'报警周报'}

    ]
  },
  {
    id: 'monitorHuiduManager',
    icon: 'fa fa-cogs',
    label: '监控管理',
    submenu: [
      {id: 'monitor-custom', path: '/monitor/custom', label: '自定义报警阈值'},
      {id: 'monitor-setting', path: '/monitor/setting/', label: '监控配置'},
      {id: 'monitor-list', path: '/monitor/list/', label: '监控展示'},
      {id: 'monitor-mantian',path: '/monitor/maintian',label:'屏蔽展示'},
      {id: 'monitor-fastalarm',path: '/monitor/fastalarm',label:'快速报警配置'},
      {id: 'monitor-report',path: '/monitor/report',label:'报警周报'},
      {id: 'monitor-alarmGroup',path: '/monitor/alarmGroup',label:'报警组配置'},
      {id: 'monitor-prometheus',path: '/monitor/prometheus',label:'prometheus报警配置'}
    ]
  },
  {
    id: 'italenManager',
    icon: 'fa fa-microchip',
    label: "考勤管理",
    submenu: [
      {id:'italen-list',path:'/italen/list/',label:'考勤展示'}
    ]
  },
  {
    id: 'cicdManager',
    icon: 'fa fa-microchip',
    label: "发版管理",
    submenu: [
      {id:'cicd-list',path:'/cicd/dashboard/',label:'发版统计'}
    ]
  },
  {
    id:'cdnManager',
    icon: 'fa fa-meetup',
    label: '基础服务管理',
    submenu : [
      {id:'slowquery-list',path:'/slowquery/list/',label:'慢查询管理'},
      {id:'cdnconfig-setting',path:'/cdnconfig/setting/',label:'cdn竞速配置管理'},
      {id:"cdnconfig-job",path:'/cdnconfig/job/',label:'cdn任务管理'},
      {id:"cdnconfig-data",path:'/cdnconfig/data',label:'cdn报表'}
    ]
  },
  // {
  //   id: 'meeting-manage',
  //   icon: 'fa fa-meetup',
  //   label: '会议室',
  //
  //   submenu: [
  //     {id: 'meeting-order', path: '/meeting/order', label: '会议室预定'},
  //     // {id: 'mb-meeting-order', path: '/mb/meeting/order', label: '移动会议室预定'},
  //   ]
  // }
]


const allow  = {
  "monitor.ushow.media" : ['monitorManager'],
  "monitor_huidu.ushow.media" : ['monitorHuiduManager'],
  "monitor-huidu.ushow.media" : ['monitorHuiduManager'],
  "cdn.ushow.media" : ["cdnManager"],
  "order.ushow.media" : ["orderManager"],
  "italen.ushow.media" : ["italenManager"],
  "cicd.ushow.media" : ["cicdManager"],
  "127.0.0.1" : ["monitorManager","orderManager","cdnManager","italenManager"],
  "10.42.3.229" : ["monitorManager","orderManager","cdnManager","italenManager","cicdManager"],

}

function menusControl() {
  let host = window.location.hostname;
  let allowList = [];
  if (allow.hasOwnProperty(host)){
      allowList = allow[host]
  }

  let menusList = [];
  menus.forEach((item,index,arr) => {
    if(allowList.indexOf(item.id) > -1){
      menusList.push(item)
    }


  });

  return menusList
}


export default menusControl



// WEBPACK FOOTER //
// ./src/views/layout/menus.js